/* eslint-disable import/prefer-default-export */
import { ITenant } from '../store/V2/TenantsSlice';

export const isFromTutopiyaTenant = (tenant?: ITenant) => {
  if (!tenant) {
    return false;
  }

  return tenant.key !== 'TUTOPIYA';
};

export const getAppBaseUrlForTenant = (tenant?: ITenant) => {
  if (!tenant) return undefined;

  const previousDomainName = (process.env.REACT_APP_BASE_URL || '')
    .replace('https://', '')
    .replace('/learning-portal', '')
    .trim();

  const newDomainName = (process.env.REACT_APP_BASE_URL || '')
    .replace(previousDomainName, tenant.domain)
    .trim();

  return newDomainName;
};
